import { colors, fonts } from '../../Components/Styles/common-styles'

const styles = {
  container: {
    padding: '30px'
  },
  modal: {
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  modalTitle1: {
    textAlign: 'center',
    fontSize: fonts.largeSize,
    fontWeight: 600,
    lineHeight: '22px',
    letterSpacing: 0,
    color: colors.black,
    marginBottom: '5px'
  },
  modalTitle2: {
    textAlign: 'center',
    fontSize: fonts.normalSize,
    fontWeight: 400,
    lineHeight: '22px',
    letterSpacing: 0,
    color: colors.grey
  },
  modalBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '150px',
    minWidth: '350px'
  },
  modalFooter: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  removeUserButton: { color: colors.errorRed }
}

export default styles
